import { FlagsmithClientProvider } from '@openfeature/flagsmith-client-provider';
import { OpenFeature } from '@openfeature/web-sdk';

// Safety net used when the FusionAuth worker hasn't set the config cookie
// (e.g. a page not behind the proxy). Production env id — fail safe rather
// than silent dev/test traffic.
const FALLBACK_FLAGSMITH_ENV_ID = 'aAjYSbfHZH4KcNh6zv5hCt';

let initialized = false;

/**
 * Read `flagsmithEnvId` from any `ciam_*_config` cookie set by the FusionAuth
 * worker. Returns null if no such cookie exists or the value is empty.
 */
function readFlagsmithEnvIdFromCookie(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(/(?:^|;\s*)ciam_[^=;]+_config=([^;]+)/);
  if (!match) return null;
  const params = new URLSearchParams(decodeURIComponent(match[1]));
  const value = params.get('flagsmithEnvId');
  return value && value.length > 0 ? value : null;
}

function resolveEnvironmentID(): string {
  const fromCookie = readFlagsmithEnvIdFromCookie();
  if (fromCookie) return fromCookie;
  console.warn(
    '[CIAM SDK] No flagsmithEnvId found in config cookie — falling back to prd. ' +
      'This usually means the page is not served through the FusionAuth worker.',
  );
  return FALLBACK_FLAGSMITH_ENV_ID;
}

export async function initFeatureFlags() {
  if (initialized) return;
  const resolved = new FlagsmithClientProvider({
    environmentID: resolveEnvironmentID(),
    cacheFlags: true,
  });
  await OpenFeature.setProviderAndWait(resolved);
  initialized = true;
}

export function useLegacyCiam(): boolean {
  return !featureFlags.getBooleanValue('use_fusionauth', false);
}

export const featureFlags = OpenFeature.getClient();
